export const props = {
  // Values
  text: String,
  description: String
}
